import React, { useCallback } from "react"

import { Box, BoxProps, IconButton } from "@chakra-ui/react"
import Icon from "@app/components/Icon"
import { useAppContext } from "@app/providers/app"
import { useConfigContext } from "@app/providers/config"

const SearchWidget: React.FC<BoxProps> = ({ ...props }) => {
  const {
    settings: { routes },
  } = useConfigContext()
  const { state, dispatch } = useAppContext()

  const onClick = useCallback(async () => {
    if (typeof window === "undefined") return

    if (window.location.pathname.includes(routes.SEARCH)) {
      const searchField = document.getElementById("results-page-form")
      searchField?.focus()
      window.scrollTo({ top: 0, behavior: "smooth" })
      return
    }

    dispatch({ type: "search", payload: !state.activeSearch })
  }, [dispatch, routes.SEARCH, state.activeSearch])

  return (
    <Box onClick={onClick}>
      <IconButton
        variant="headerIcon"
        aria-label="Open search"
        icon={<Icon name="search" width="48px" height="48px" p={3.5} />}
        cursor="pointer"
        {...props}
      />
    </Box>
  )
}

export default React.memo(SearchWidget)
